import React from 'react';
import { twMerge } from 'tailwind-merge';

interface FloatingCardProps {
  children: React.ReactNode;
  className?: string;
  position?: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';
  delayed?: boolean;
}

const positionClasses = {
  'top-left': '-top-4 -left-4 lg:-top-6 lg:-left-6',
  'top-right': '-top-4 -right-4 lg:-top-6 lg:-right-6',
  'bottom-left': '-bottom-4 -left-4 lg:-bottom-6 lg:-left-6',
  'bottom-right': '-bottom-4 -right-4 lg:-bottom-6 lg:-right-6',
};

export default function FloatingCard({
  children,
  className,
  position = 'top-left',
  delayed = false,
}: FloatingCardProps) {
  return (
    <div
      className={twMerge(
        'absolute z-10 glass rounded-xl px-4 py-3 text-white text-sm font-medium shadow-2xl',
        delayed ? 'animate-float-delayed' : 'animate-float',
        positionClasses[position],
        className
      )}
    >
      {children}
    </div>
  );
}
